import { cx } from "class-variance-authority";
import Panel from "../panel";
import { SelectOption } from "../select/types";

interface ControlTabOption extends SelectOption {
  render: React.ReactNode;
  isDisabled?: boolean;
}

export const ControlTabs = <SelectedType extends string>(props: {
  items: ControlTabOption[];
  selected: SelectedType;
  setSelected: (index: SelectedType) => void;
}) => {
  return (
    <Panel className="border-dublin-gray w-full rounded border">
      <ul className="divide-y">
        {props.items.map((item, index) => {
          return (
            <li
              key={item.value + index}
              className={cx(
                props.selected === item.value
                  ? "border-l-navy-sailor overflow-hidden  border-l-[3px]"
                  : "",
                index === 0
                  ? "rounded-tl"
                  : index === props.items.length - 1
                  ? "rounded-bl"
                  : null,
                "border-dublin-gray cursor-pointer",
                item.isDisabled
                  ? "pointer-events-none opacity-50"
                  : "cursor-pointer",
              )}
            >
              <button
                onClick={() => {
                  if (!item.isDisabled && props.selected !== item.value) {
                    props.setSelected(item.value as SelectedType);
                  }
                }}
                className={cx(
                  "w-full p-4",
                  "text-base font-medium",
                  props.selected === item.value
                    ? "text-navy-sailor"
                    : "text-dark-elephant",
                )}
              >
                {item.render}
              </button>
            </li>
          );
        })}
      </ul>
    </Panel>
  );
};
